import React from "react";
import { toast } from "react-toastify";
import {
    Breadcrumb,
    BreadcrumbItem,
    Button,
    Card,
    CardBody,
    CardHeader,
    FormGroup,
    Input,
    Label,
    Spinner
} from "reactstrap";
import UploadFiles from "../../components/attachment/UploadFiles";
import { ATTACHMENT_CATEGORY_SPARE_PART } from "../../store/AppConstants";
import SparePartService from "../../services/SparePartService";
import UserService from "../../services/UserService";

class SparePartDetails extends React.Component {
    constructor(props) {
        super(props);

        const sparePart = props.location.state?.sparePart || null;
        const isEdit = !!sparePart;

        this.state = {
            loading: false,
            isEdit,
            offRangeCode: sparePart?.offRangeCode || null,
            description: sparePart?.description || "",
            price: sparePart?.price || "",
            sparePartGroupId: sparePart?.sparePartGroupID || props.location.state.selectedGroup || null,
            sparePartSubGroupId: sparePart?.sparePartSubGroupID || null,
            thumbnailImageAttachment: sparePart?.thumbnailImageAttachment || null,
            highQualityImageAttachment: sparePart?.highQualityImageAttachment || null,
            thumbnailImageAttachmentID: sparePart?.thumbnailImageAttachmentID || "",
            highQualityImageAttachmentID: sparePart?.highQualityImageAttachmentID || "",
            sparePartGroups: [],
            sparePartSubGroups: [],
            user: {},
            errors: {},
            saving: false,
        };

        this.SparePartService = new SparePartService();
        this.userService = new UserService();
    }

    validate = () => {
        const errors = {};
        if (!this.state.offRangeCode) {
            errors.offRangeCode = "Off Range Code is required";
        }
        if (!this.state.sparePartGroupId) {
            errors.sparePartGroupId = "Spare Part Group is required";
        }
        this.setState({ errors });
        return Object.keys(errors).length === 0;
    }

    componentDidMount() {
        let user = this.userService.getLoggedInUser();
        this.setState({ user });
        this.getSparePartGroups();
        this.getSparePartsubGroups();
    }

    getSparePartGroups = () => {
        this.SparePartService.listGroups({
            pageRequest: {
                currentPage: 0,
                pageSize: 0
            },
            sortRequest: {
                key: "",
                direction: false
            },
            filterRequest: {
                name: "",
                groupID: 0,
            },
        })
            .then(res => {
                this.setState({ sparePartGroups: res.data.records || [] });
            })
            .catch(() => { });
    };

    getSparePartsubGroups = () => {
        if (!this.state.sparePartGroupId) {
            this.setState({ sparePartSubGroups: [] });
            return;
        }
        this.SparePartService.listSubGroups({
            pageRequest: {
                currentPage: 0,
                pageSize: 0
            },
            sortRequest: {
                key: "",
                direction: false
            },
            filterRequest: {
                name: "",
                groupID: this.state.sparePartGroupId,
            },
        })
            .then(res => {
                this.setState({ sparePartSubGroups: res.data.records || [] });
            })
            .catch(() => { });
    };

    handleCancel() {
        this.props.history.push('/sparepart');
    }

    handleSave() {
        if (!this.validate()) {
            return;
        }
        const { offRangeCode, sparePartGroupId, sparePartSubGroupId, thumbnailImageAttachmentID, highQualityImageAttachmentID } = this.state;
        const payload = {
            prodCode: offRangeCode, sparePartGroupId, sparePartSubGroupId, thumbnailImageAttachmentID, highQualityImageAttachmentID
        };

        this.setState({ saving: true });
        this.SparePartService.saveSparePart(payload)
            .then(() => {
                toast.success("Saved successfully");
                this.props.history.push("/sparepart");
            })
            .catch((err) => {
                const message =
                    err.response?.data?.Message || "Failed to save";
                toast.error(message);
            }).finally(() => {
                this.setState({ saving: false });
            });
    };

    render() {
        const { isEdit, offRangeCode, description, price, sparePartGroupId, sparePartSubGroupId, thumbnailImageAttachment, highQualityImageAttachment, sparePartGroups, sparePartSubGroups, thumbnailImageAttachmentID, highQualityImageAttachmentID, errors, saving } = this.state;

        return (
            <>
                <Breadcrumb tag="nav" listTag="div">
                    <BreadcrumbItem
                        tag="a"
                        href="javascript:void(0)"
                        onClick={() => this.props.history.push('/')}
                    >
                        Home
                    </BreadcrumbItem>

                    <BreadcrumbItem
                        tag="a"
                        href="javascript:void(0)"
                        onClick={() => this.props.history.push('/sparepart')}
                    >
                        Spare Parts
                    </BreadcrumbItem>

                    <BreadcrumbItem active tag="span">
                        Spare Part Details
                    </BreadcrumbItem>
                </Breadcrumb>

                <Card>
                    <CardHeader>
                        {isEdit ? "Edit Spare Part" : "Add Spare Part"}
                    </CardHeader>

                    <CardBody>

                        <FormGroup>
                            <Label>Off Range Code</Label>
                            <Input
                                value={offRangeCode}
                                onChange={(e) =>
                                    this.setState({ offRangeCode: e.target.value })
                                }
                            />
                            {errors.offRangeCode && (
                                <div className="text-danger">{errors.offRangeCode}</div>
                            )}
                        </FormGroup>

                        {isEdit && (
                            <>
                                <FormGroup>
                                    <Label>Description</Label>
                                    <Input
                                        value={description || ""}
                                        readOnly
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label>Price</Label>
                                    <Input
                                        value={price != null ? price : ""}
                                        readOnly
                                    />
                                </FormGroup>
                            </>
                        )}


                        <FormGroup>
                            <Label>Group</Label>

                            <Input type={"select"}
                                value={sparePartGroupId}
                                onChange={(e) => {
                                    this.setState({ sparePartGroupId: e.target.value }, () => {
                                        this.getSparePartsubGroups();
                                    })
                                }}
                                placeholder="Select Group"
                            >
                                {sparePartGroups.map(group => (
                                    <option key={group.id} value={group.id}>{group.name}</option>
                                ))}
                            </Input>
                            {errors.sparePartGroupId && (
                                <div className="text-danger">{errors.sparePartGroupId}</div>
                            )}
                        </FormGroup>

                        <FormGroup>
                            <Label>Sub Group</Label>

                            <Input type={"select"}
                                value={sparePartSubGroupId}
                                onChange={(e) => {
                                    this.setState({ sparePartSubGroupId: e.target.value })
                                }}
                            >
                                <option value={null}>None</option>
                                {sparePartSubGroups.map(subGroup => (
                                    <option key={subGroup.id} value={subGroup.id}>{subGroup.name}</option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label>Thumbnail Image</Label>
                            <UploadFiles
                                isReadOnly={false}
                                category={ATTACHMENT_CATEGORY_SPARE_PART}
                                handleChange={(change) => this.setState({ thumbnailImageAttachmentID: change })}
                                attachmentIDs={thumbnailImageAttachmentID} />
                        </FormGroup>

                        <FormGroup>
                            <Label>High-Quality Image</Label>
                            <UploadFiles
                                isReadOnly={false}
                                category={ATTACHMENT_CATEGORY_SPARE_PART}
                                handleChange={(change) => this.setState({ highQualityImageAttachmentID: change })}
                                attachmentIDs={highQualityImageAttachmentID} />
                        </FormGroup>

                        <FormGroup>
                            <div className="pb-2 text-right">
                                <Button
                                    size="sm"
                                    color="primary"
                                    onClick={() => this.handleSave()}
                                >
                                    {saving
                                        ? <Spinner size="sm"
                                            className={"mr-2"}
                                            style={{ color: "white" }} />
                                        : <i className="fa fa-floppy-o mr-2" />}
                                    Save
                                </Button>
                                <span>&nbsp;&nbsp;</span>
                                <Button
                                    size="sm"
                                    color="secondary"
                                    onClick={() => this.handleCancel()}
                                >
                                    <i className="fa fa-times" />&nbsp;
                                    Cancel
                                </Button>
                            </div>
                        </FormGroup>

                    </CardBody>
                </Card>
            </>
        );
    }
}

export default SparePartDetails;